module.exports = __webpack_public_path__ + "static/img/bg-pt.f321d303.webp";